module.exports = __webpack_public_path__ + "static/media/parking-inventory-system.efe4e148.jpg";